export default __webpack_public_path__ + "locales/fi/EmbeddingPanel.json?hash=8c0beb238f749c6a8744ad3b99f0b1fd";